import React from "react";
import { cn } from "../../utils/cn";

export default function Card({ className, children }) {
  return (
    <div
      className={cn(
        "rounded-2xl border border-white/10 bg-white/5 p-6 shadow-sm backdrop-blur",
        className,
      )}
    >
      {children}
    </div>
  );
}
